import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { ConfirmProvider } from "material-ui-confirm";
import { useSelector } from "react-redux";

import theme from "./theme";
import NavBar from "./components/NavBar/NavBar";
import GamesMenu from "./components/Games/GamesMenu";
import GameSetup from "./components/Games/GameSetup";
import FlagsAndCapitals from "./components/Games/Flags&Capitals/FlagsAndCapitals";
import HighLow from "./components/Games/HighLow/HighLow";
import Lookup from "./components/Lookup/Lookup";
import MobileLookup from "./components/Lookup/MobileLookup";
import Lists from "./components/Games/Lists/Lists";
import Maps from "./components/Games/Maps/Maps";
import Highscores from "./components/Highscores/Highscores";
import Help from "./components/Help/Help";

const App = () => {
  const { game, prevGame } = useSelector((state) => state.game);

  return (
    <ThemeProvider theme={theme}>
      <ConfirmProvider>
        <Router>
          <CssBaseline />
          <NavBar />
          <Routes>
            <Route exact path="/" element={<GamesMenu />} />
            <Route
              exact
              path="/flags"
              element={
                game ? (
                  <FlagsAndCapitals game={game} />
                ) : (
                  <GameSetup
                    prevGame={prevGame}
                    title="Flags"
                    options={["Multiple Choice", "Type Answer"]}
                  />
                )
              }
            />
            <Route
              exact
              path="/capitals"
              element={
                game ? (
                  <FlagsAndCapitals game={game} />
                ) : (
                  <GameSetup
                    prevGame={prevGame}
                    title="Capitals"
                    options={["Multiple Choice", "Type Answer"]}
                  />
                )
              }
            />
            <Route
              exact
              path="/highlow"
              element={
                game ? (
                  <HighLow game={game} />
                ) : (
                  <GameSetup
                    prevGame={prevGame}
                    title="HighLow"
                    options={["Population", "Area", "Density"]}
                  />
                )
              }
            />
            <Route
              exact
              path="/lookup"
              element={window.innerWidth < 725 ? <MobileLookup /> : <Lookup />}
            />
            <Route
              exact
              path="/lists"
              element={
                game ? (
                  <Lists game={game} />
                ) : (
                  <GameSetup prevGame={prevGame} title="Lists" />
                )
              }
            />
            <Route
              exact
              path="/maps"
              element={
                game ? (
                  <Maps game={game} />
                ) : (
                  <GameSetup prevGame={prevGame} title="Maps" />
                )
              }
            />
            <Route exact path="/highscores" element={<Highscores />} />
            <Route exact path="/help" element={<Help />} />
          </Routes>
        </Router>
      </ConfirmProvider>
    </ThemeProvider>
  );
};

export default App;
